module.exports = __webpack_public_path__ + "ed12fb48005787ed9dc313bd76104fba.pdf";